<h2 mat-dialog-title>Vorhöhenkontrolle</h2>
<mat-dialog-content>
    Am <b>{{data.timestamp | date:'dd.MM.yyyy HH:mm:ss'}}</b> wurde die Vorhöhenkontrolle in <b>{{ aktiveGroup?.name
        }}</b> ausgelöst.

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onIgnore()">Ok</button>
    <button mat-raised-button (click)="onAufnahmenClicked()">Aufnahmen</button>
    <button mat-raised-button color="primary" (click)="onStream()">Zum Stream</button>
</mat-dialog-actions>